import { ICreatePatrimonioCentroCustoUseCase } from "../../../presentation/useCases/create/create_patrimonio_centro_custo_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * CreatePatrimonioCentroCustoUseCase
 */

export class CreatePatrimonioCentroCustoUseCase implements ICreatePatrimonioCentroCustoUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async createPatrimonioCentroCusto(
    idCentroCusto?: number | null,
    status?: number | null,
  ): Promise<number> {
    return await this.repository.createPatrimonioCentroCusto(
      idCentroCusto,
      status,
    );
  }
}
